// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../api";
// import "./classesandForm.css"; // Unified CSS

// // Helper to validate email
// const validateEmail = (email) => {
//   const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return re.test(String(email).toLowerCase());
// };

// export default function ClassPage2() {
//   const [portfolioItems, setPortfolioItems] = useState([]);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
//   const [selectedSlot, setSelectedSlot] = useState("");
//   const [submitted, setSubmitted] = useState(false);
//   const [phoneError, setPhoneError] = useState("");
//   const [emailError, setEmailError] = useState("");

//   const navigate = useNavigate();
//   const isRegistrationClosed = (endDate) => {
//     if (!endDate) return false;
//     return new Date() > new Date(endDate);
//   };

//   const getTimeLeft = (endDate) => {
//     if (!endDate) return null;

//     const diff = new Date(endDate) - new Date();
//     if (diff <= 0) return "Registration closed";

//     const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
//     const minutes = Math.floor((diff / (1000 * 60)) % 60);

//     if (days > 0) return `Ends in ${days}d ${hours}h`;
//     if (hours > 0) return `Ends in ${hours}h ${minutes}m`;
//     return `Ends in ${minutes}m`;
//   };

//   // Simulated Fetch (Replace with your API logic)
//   useEffect(() => {
//     API.get("api/classes")
//       .then((res) => setPortfolioItems(res.data))
//       .catch((err) => console.error("Fetch Error:", err));
//   }, []);

//   const handleEnrollClick = (item) => {
//     if (isRegistrationClosed(item.registrationEnd)) return;
//     if (item.enrollmentType === "navigate" && item.path) {
//       navigate(item.path, {
//         state: {
//           productName: item.title,
//           amount: item.price,
//           description: item.description,
//           quantity: 1,
//         },
//       });
//     } else {
//       setSelectedClass(item);
//       setSelectedSlot(item.slots?.[0] || "");
//       setSubmitted(false);
//       setFormData({ name: "", email: "", phone: "" });
//       setPhoneError("");
//       setEmailError("");
//     }
//   };

//   const handleCloseModal = () => setSelectedClass(null);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone") {
//       const num = value.replace(/[^0-9]/g, "");
//       if (num.length <= 10) setFormData((prev) => ({ ...prev, [name]: num }));
//       if (phoneError) setPhoneError("");
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//       if (name === "email") setEmailError("");
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     let isValid = true;

//     if (!validateEmail(formData.email)) {
//       setEmailError("Invalid email address.");
//       isValid = false;
//     }
//     if (formData.phone.length !== 10) {
//       setPhoneError("Phone must be 10 digits.");
//       isValid = false;
//     }

//     if (!isValid) return;

//     API.post("/enroll", {
//       ...formData,
//       className: selectedClass.title,
//       slot: selectedSlot,
//       description: "Modal enrollment",
//     })
//       .then(() => setSubmitted(true))
//       .catch(() => alert("Enrollment failed."));
//   };

//   return (
//     <div id="target-section">
//       <div className="portfolio-container">
//         <div className="portfolio-inner">
//           <h1 className="main-title">Our Classes</h1>
//           <p className="section-subtitle">
//             Practical wisdom for a Satvic lifestyle.
//           </p>

//           <div className="portfolio-grid">
//             {portfolioItems.map((item) => (
//               // <div
//               //   key={item.id}
//               //   className="portfolio-card"
//               //   onClick={() => handleEnrollClick(item)}
//               // >
//               <div
//                 key={item.id}
//                 className={`portfolio-card ${
//                   isRegistrationClosed(item.registrationEnd)
//                     ? "disabled-card"
//                     : ""
//                 }`}
//                 onClick={() => handleEnrollClick(item)}
//               >
//                 <img
//                   src={item.imageUrl}
//                   alt={item.title}
//                   className="card-image"
//                 />
//                 <div className="card-gradient-overlay"></div>
//                 {item.registrationEnd && (
//                   <div className="card-timer">
//                     {getTimeLeft(item.registrationEnd)}
//                   </div>
//                 )}

//                 {item.price > 0 && (
//                   <div className="card-price">₹{item.price}</div>
//                 )}

//                 <div className="card-hover-content">
//                   <h3 className="card-title">{item.title}</h3>
//                   <p className="card-description">{item.description}</p>
//                   {/* <button className="card-button">
//                     {item.price > 0 ? "Register Now" : "Enroll Free"}
//                   </button> */}
//                   <button
//                     className="card-button"
//                     disabled={isRegistrationClosed(item.registrationEnd)}
//                   >
//                     {isRegistrationClosed(item.registrationEnd)
//                       ? "Registration Closed"
//                       : item.price > 0
//                       ? "Register Now"
//                       : "Enroll Free"}
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       {selectedClass && (
//         <div className="modal-overlay">
//           <div className="modal">
//             {submitted ? (
//               <div style={{ textAlign: "center" }}>
//                 <h3>Thank you!</h3>
//                 <p>We will be in touch shortly.</p>
//                 <button
//                   className="submit-btn"
//                   onClick={handleCloseModal}
//                   style={{ marginTop: "20px" }}
//                 >
//                   Close
//                 </button>
//               </div>
//             ) : (
//               <>
//                 <div className="modal-header">
//                   <h3>Enroll in {selectedClass.title}</h3>
//                 </div>
//                 <form
//                   onSubmit={handleSubmit}
//                   className="enroll-form"
//                   noValidate
//                 >
//                   <input
//                     type="text"
//                     name="name"
//                     placeholder="Full Name"
//                     required
//                     value={formData.name}
//                     onChange={handleInputChange}
//                   />

//                   <input
//                     type="email"
//                     name="email"
//                     placeholder="Email Address"
//                     required
//                     value={formData.email}
//                     onChange={handleInputChange}
//                   />
//                   {emailError && <p className="error-message">{emailError}</p>}

//                   <input
//                     type="tel"
//                     name="phone"
//                     placeholder="Phone Number"
//                     required
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                   />
//                   {phoneError && <p className="error-message">{phoneError}</p>}

//                   {selectedClass.slots && (
//                     <select
//                       value={selectedSlot}
//                       onChange={(e) => setSelectedSlot(e.target.value)}
//                     >
//                       {selectedClass.slots.map((slot, idx) => (
//                         <option key={idx} value={slot}>
//                           {slot}
//                         </option>
//                       ))}
//                     </select>
//                   )}

//                   <div className="form-buttons">
//                     <button type="submit">Confirm</button>
//                     <button
//                       type="button"
//                       className="cancel-btn"
//                       onClick={handleCloseModal}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import './classesandForm.css';

/* ---------------- Helpers ---------------- */

const validateEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());

const isRegistrationClosed = (endDate) => {
  if (!endDate) return false;
  return new Date() > new Date(endDate);
};

const getTimeLeft = (endDate) => {
  if (!endDate) return null;

  const diff = new Date(endDate) - new Date();
  if (diff <= 0) return 'Registration Closed';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);

  if (days > 0) return `Ends in ${days}d ${hours}h`;
  if (hours > 0) return `Ends in ${hours}h ${minutes}m`;
  return `Ends in ${minutes}m`;
};

const getTimerClass = (endDate) => {
  if (!endDate) return '';
  const diff = new Date(endDate) - new Date();
  if (diff <= 0) return 'closed';
  if (diff < 24 * 60 * 60 * 1000) return 'ending-soon';
  return '';
};

/* ---------------- Skeleton ---------------- */

const SkeletonCard = () => (
  <div className="portfolio-card" style={{ background: '#eaeaea' }} />
);

/* ---------------- Component ---------------- */

export default function ClassPage2() {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [selectedSlot, setSelectedSlot] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0); // forces timer refresh

  const navigate = useNavigate();

  /* -------- Fetch classes (with abort + cache-friendly) -------- */

  useEffect(() => {
    const controller = new AbortController();

    API.get('api/classes', { signal: controller.signal })
      .then(res => setPortfolioItems(res.data))
      .catch(err => {
        if (err.name !== 'CanceledError') {
          console.error('Fetch Error:', err);
        }
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, []);

  /* -------- Live timer refresh every minute -------- */

  useEffect(() => {
    const interval = setInterval(() => {
      setTick(t => t + 1);
    }, 60000); // 1 minute

    return () => clearInterval(interval);
  }, []);

  /* ---------------- Handlers ---------------- */

  const handleEnrollClick = (item) => {
    if (isRegistrationClosed(item.registrationEnd)) return;

    if (item.enrollmentType === 'navigate' && item.path) {
      // navigate(item.path, {
      //   state: {
      //     productName: item.title,
      //     amount: item.price,
      //     description: item.description,
      //     quantity: 1,
      //   },
      // });
      navigate(`${item.path}?classId=${item.id}`, {
        state: {
          productName: item.title,
          amount: item.price,
          description: item.description,
          quantity: 1,
        },
      });
    } else {
      setSelectedClass(item);
      setSelectedSlot(item.slots?.[0] || '');
      setSubmitted(false);
      setFormData({ name: '', email: '', phone: '' });
      setPhoneError('');
      setEmailError('');
    }
  };

  const handleCloseModal = () => setSelectedClass(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const num = value.replace(/[^0-9]/g, '');
      if (num.length <= 10) setFormData(p => ({ ...p, phone: num }));
      setPhoneError('');
    } else {
      setFormData(p => ({ ...p, [name]: value }));
      if (name === 'email') setEmailError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let valid = true;
    if (!validateEmail(formData.email)) {
      setEmailError('Invalid email address');
      valid = false;
    }
    if (formData.phone.length !== 10) {
      setPhoneError('Phone must be 10 digits');
      valid = false;
    }
    if (!valid) return;

    API.post('/enroll', {
      ...formData,
      className: selectedClass.title,
      slot: selectedSlot,
      description: 'Modal enrollment',
    })
      .then(() => setSubmitted(true))
      .catch(err => {
        if (err.response?.status === 403) {
          alert('Registrations for this class are closed.');
          handleCloseModal();
        } else {
          alert('Enrollment failed.');
        }
      });
  };

  /* ---------------- Render ---------------- */

  return (
    <div id="target-section">
      <div className="portfolio-container">
        <div className="portfolio-inner">
          <h1 className="main-title">Our Classes</h1>
          <p className="section-subtitle">
            Practical wisdom for a Satvic lifestyle.
          </p>

          <div className="portfolio-grid">
            {loading &&
              Array.from({ length: 3 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))}

            {!loading &&
              portfolioItems.map(item => {
                const closed = isRegistrationClosed(item.registrationEnd);

                return (
                  <div
                    key={item.id}
                    className={`portfolio-card ${
                      closed ? 'disabled-card' : ''
                    }`}
                    onClick={() => handleEnrollClick(item)}
                  >
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="card-image"
                      loading="lazy"
                    />

                    <div className="card-gradient-overlay" />

                    {item.price > 0 && (
                      <div className="card-price">₹{item.price}</div>
                    )}

                    {item.registrationEnd && (
                      <div
                        className={`card-timer ${getTimerClass(
                          item.registrationEnd
                        )}`}
                      >
                        {getTimeLeft(item.registrationEnd)}
                      </div>
                    )}

                    <div className="card-hover-content">
                      <h3 className="card-title">{item.title}</h3>
                      <p className="card-description">{item.description}</p>
                      <button className="card-button">
                        {closed
                          ? 'Registration Closed'
                          : item.price > 0
                          ? 'Register Now'
                          : 'Enroll Free'}
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {/* ---------------- Modal ---------------- */}

      {selectedClass && (
        <div className="modal-overlay">
          <div className="modal">
            {submitted ? (
              <div style={{ textAlign: 'center' }}>
                <h3>Thank you!</h3>
                <p>We will be in touch shortly.</p>
                <button
                  className="submit-btn"
                  onClick={handleCloseModal}
                  style={{ marginTop: 20 }}
                >
                  Close
                </button>
              </div>
            ) : (
              <>
                <div className="modal-header">
                  <h3>Enroll in {selectedClass.title}</h3>
                </div>

                <form onSubmit={handleSubmit} className="enroll-form" noValidate>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  {emailError && (
                    <p className="error-message">{emailError}</p>
                  )}

                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    required
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                  {phoneError && (
                    <p className="error-message">{phoneError}</p>
                  )}

                  {selectedClass.slots && (
                    <select
                      value={selectedSlot}
                      onChange={(e) => setSelectedSlot(e.target.value)}
                    >
                      {selectedClass.slots.map((slot, i) => (
                        <option key={i} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>
                  )}

                  <div className="form-buttons">
                    <button type="submit">Confirm</button>
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
